<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    id="printDev"
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <InvoiceHeader invoice_type="incomes_list" v-if="isHide == true" />
    
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700" v-if="isHide != true">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("incomes_list") }}
      </h1>
    </div>

    <!-- Table Section -->
    <div class="px-6 py-4">
      <div class="relative overflow-x-auto">
        <div class="flex items-center justify-between pb-4  no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.income_list.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            /> <button
              class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
              @click="printReportFunc"
              id="button_print"
              v-if="$store.getters['checkPrintAccess']"
            >
              {{ $t("print") }}
            </button>
          </div>
          
          <div class="flex items-center space-x-4">
            <CustomMultiSelect
              v-model="selectedHeaders"
              :options="headers"
              track-by="value"
              label="text"
              :placeholder="$t('columns')"
              :header-text="$t('which_columns_to_display')"
              @update:modelValue="printCall"
            />
            <div class="w-0.5"></div>
            <button
              @click="resetToDefaultHeaders"
              class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
              :title="$t('reset_to_default')"
            >
              <i class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"></i>
            </button>
           
          </div>
        </div>
        <!--in ltr change (text-right to text-left)
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          alternating
          :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
          :loading="isLoadingData"
          :class="isDark ? 'customize-table ' : 'light-mode-table'"
        >
          <template #default="{ column, sortDirection }">
            <span class="custom-sort-icon" v-if="column.sortable">
              <i
                v-if="sortDirection === 'asc'"
                class="fa-solid fa-arrow-up-wide-short"
              ></i>
              <i
                v-else-if="sortDirection === 'desc'"
                class="fa-solid fa-arrow-up-wide-short"
              ></i>
              <i v-else class="fa-solid fa-arrow-up-wide-short"></i>
            </span>
            {{ column.label }} </template
          ><template #item-inc_image="item">
            <img
              :src="file_url + item.inc_image"
              class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-20 w-20 rounded-xl"
              v-if="item.inc_image"
              @click="openModal(file_url + item.inc_image)"
            />
            <span v-if="item.inc_image == '' || item.inc_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #item-actions="item">
            <button class="mx-1" @click="showModal(item)">
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button class="mx-1" @click="deleteItem(item.inc_id)">
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
            <a class="mx-1" :href="'income-detail/' + item.inc_id">
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a></template
          ><template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }}
          </template>
          <template #loading>
            <div class="flex justify-center items-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          </template>
          <template #item-inc_note="item">
            <span
              v-if="item.inc_note == null || item.inc_note == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.inc_note }}
            </span>
          </template>
          <template #item-customer_cu_name="item">
            <span
              v-if="item.customer == null || item.customer == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.customer.cu_name }}
            </span>
          </template>
          <template #item-inc_wasl="item">
            <span
              v-if="item.inc_wasl == null || item.inc_wasl == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.inc_wasl }}
            </span>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-8 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-right'
                    : ' fa-chevron-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-left'
                    : ' fa-chevron-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>-->
        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
        >
          <template #default="{ column, sortDirection }">
            <span class="custom-sort-icon" v-if="column.sortable">
              <i
                v-if="sortDirection === 'asc'"
                class="fa-solid fa-arrow-up"
              ></i>
              <i
                v-else-if="sortDirection === 'desc'"
                class="fa-solid fa-arrow-down"
              ></i>
              <i v-else class="fa-solid fa-arrows-up-down"></i>
            </span>
            {{ column.label }}
          </template>
          <template #item-inc_image="item">
            <img
              :src="file_url + item.inc_image"
              class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-20 w-20 rounded-xl"
              v-if="item.inc_image"
              @click="openModal(file_url + item.inc_image)"
            />
            <span v-if="item.inc_image == '' || item.inc_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '25',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.inc_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '25',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
            <a
              class="mx-1 my-1"
              target="_blank"
              :href="'income-detail/' + item.inc_id"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '25',
                  action: 'detail',
                })
              "
            >
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a></template
          ><template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }}
          </template>
          <template #loading>
            <div class="flex justify-center items-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          </template>
          <template #item-inc_note="item">
            <span
              v-if="item.inc_note == null || item.inc_note == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.inc_note }}
            </span>
          </template>
          <template #item-inc_amount="item">
            {{ formatNumber(item.inc_amount) }}
          </template>
          <template #item-customer_cu_name="item">
            <span
              v-if="item.customer == null || item.customer == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.customer.cu_name }}
            </span>
          </template>
          <template #item-inc_wasl="item">
            <span
              v-if="item.inc_wasl == null || item.inc_wasl == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.inc_wasl }}
            </span>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-8 text-gray-500 dark:text-gray-400">
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button> </template
        ></EasyDataTable>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.inc_amount"
          :label="$t('money_amount')"
          :placeholder="$t('income_amount')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.inc_amount, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.inc_amount, 'edit', this.rules).errorMsg
          "
        />
        <DropdownInput
          v-model="current.ic_id"
          :label="$t('income_category')"
          :placeholder="$t('choose_income_category')"
          :rules="rules_dropdown"
          :items="convertToListIdValueIncomeCategory"
          :isError="
            checkRulesIsError(current.ic_id, 'edit', this.rules_dropdown)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.ic_id, 'edit', this.rules_dropdown)
              .errorMsg
          "
        /><DropdownInput
          v-model="current.cu_id"
          :label="$t('customer')"
          :placeholder="$t('choose_if_your_income_is_from_customer')"
          :rules="[]"
          :items="convertToListIdValueCustomers"
          :isError="checkRulesIsError(current.cu_id, 'edit', []).isError"
          :errorMsg="checkRulesIsError(current.cu_id, 'edit', []).errorMsg"
        />
        <BaseInput
          v-model="current.inc_wasl"
          :label="$t('income_invoice_number')"
          :placeholder="$t('income_invoice_number')"
          :rules="[]"
          :isError="checkRulesIsError(current.inc_wasl, 'edit', []).isError"
          :errorMsg="checkRulesIsError(current.inc_wasl, 'edit', []).errorMsg"
        />
        <BaseInput
          v-model="current.created_at"
          type="date"
          :label="$t('income_date')"
          :placeholder="$t('income_date')"
          :rules="rules"
          :isError="
            checkRulesIsError(current.created_at, 'add', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.created_at, 'add', this.rules).errorMsg
          "
        />
        <FileInput
          v-model="inc_image"
          :label="$t('income_photo')"
          :placeholder="$t('choose_income_photo')"
          accept="image/*"
          :show-preview="true"
          @change="onChange"
        />
        <TextAreaInput
          v-model="current.inc_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="[]"
          :isError="checkRulesIsError(current.inc_note, 'edit', []).isError"
          :errorMsg="checkRulesIsError(current.inc_note, 'edit', []).errorMsg"
        />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div> </edit-modal
  ><image-modal ref="imageModal" />
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import { formatDate, formatNumber } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import { FILE_URL } from "../../constants/config";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    CustomMultiSelect,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    DropdownInput,
    TextAreaInput,
    ImageModal,
    InvoiceHeader,
    FileInput,
  },
  data() {
    return {
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      ic_name: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      inc_image: "",
      file_url: FILE_URL,
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      isHide: false,
      selectedHeaders: [],
    };
  },
  created() {
    this.$store.dispatch("income_category/getIncomeCategory");
    this.$store.dispatch("customer/getCustomers");
    this.$store.dispatch("navbar/getItems");
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.income_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.income_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("income_list/SET_DELETE_SUCCESS", false);
      }
    },
  },
  mounted() {
    // First load when the component is mounted
    if (
      this.$store.getters["checkUserAccess"]({
        id: "25",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
    this.loadSelectedHeaders();
  },
  computed: {
    getResultDialog() {
      return this.$store.state.income_list.isShowResultDialog;
    },

    filterItems() {
      return this.$store.getters["income_list/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.income_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.income_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.income_list.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        { text: "#", value: "inc_id", sortable: true },
        {
          text: this.$t("income_invoice_number"),
          value: "inc_wasl",
          sortable: true,
        },
        { text: this.$t("photo"), value: "inc_image", sortable: false },
        { text: this.$t("income_amount"), value: "inc_amount", sortable: true },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: true,
        },
        {
          text: this.$t("dolar_price"),
          value: "inc_main_currency_price",
          sortable: true,
        },
        {
          text: this.$t("income_category"),
          value: "income_category.ic_name",
          sortable: true,
        },
        { text: this.$t("income_box"), value: "box.bo_name", sortable: true },
        {
          text: this.$t("customer"),
          value: "customer_cu_name",
          sortable: true,
        },
        { text: this.$t("note"), value: "inc_note", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      if (this.isHide) {
        listHeader.pop();
      }
      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id.toString(),
          value: item.cu_name,
        });
      }

      return list;
    },
    convertToListIdValueIncomeCategory() {
      var incomeCategory = this.$store.state.income_category.incomeCategory;
      var list = [];
      for (const item of incomeCategory) {
        list.push({
          id: item.ic_id.toString(),
          value: item.ic_name,
        });
      }

      return list;
    },
  },

  methods: {
    formatNumber(number) {
      return formatNumber(number);
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();  // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    handleSearchInput(value) {
      this.$store.commit('income_list/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("incomeSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "incomeSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.income_list.search;

      const res = await this.$store.dispatch("income_list/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    onChange(e) {
      this.inc_image = e.target.files[0];
      e.target.value = "";
    },

    showImage(url) {
      window.open(url, "_blank");
    },
    formatDate(date) {
      return formatDate(date);
    },

    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";

      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("income_list/REMOVE_ITEM", id);
        await this.$store.dispatch("income_list/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      //if not null
      if (this.current.ic_id != null)
        this.current.ic_id = item.income_category.ic_id.toString();
      if (this.current.cu_id != null)
        this.current.cu_id = item.customer.cu_id.toString();
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.ic_id, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.inc_amount, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.created_at, "edit", this.rules)
          .isError
      ) {
        return;
      }
      this.$store.state.income_list.isBtnEditLoading = true;
      var res = await this.$store.dispatch("income_list/editItem", {
        inc_id: this.current.inc_id,
        ic_id: this.current.ic_id,
        cu_id: this.current.cu_id,
        inc_note: this.current.inc_note,
        inc_wasl: this.current.inc_wasl,
        inc_amount: this.current.inc_amount,
        created_at: this.current.created_at,
        inc_image: this.inc_image,
      });

      this.isSubmitedEdit = false;
      this.$store.state.income_list.isBtnEditLoading = false;
      this.inc_image = "";
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
  },
};
</script>
